import { getEnumObject } from '../utilities.js';

export const loanTypes = {
  SUPPLY: 2,
  TANMEYA: 1,
};

export default getEnumObject(loanTypes);
